import React from "react";
export function renderNodeOrComponent(node, props) {
    if (!node) {
        return null;
    }
    else if (React.isValidElement(node)) {
        return React.cloneElement(node, props);
    }
    else if (typeof node === "string" || typeof node === "number" || node === true) {
        return node;
    }
    else {
        return React.createElement(node, props);
    }
}
//# sourceMappingURL=render-node-or-component.js.map